import React from "react";
import { Instagram, Youtube, Phone, MapPin, Mail } from "lucide-react";
import { useSettings } from "../lib/queries";
import { useLang } from "../lib/i18n";

export default function Footer() {
  const { data: settings } = useSettings();
  const { lang, pick } = useLang();
  if (!settings) return null;
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-6">
            <span className="w-2.5 h-2.5 rounded-full bg-[#A855F7] shadow-[0_0_16px_rgba(168,85,247,0.8)]" />
            <span className="font-display text-lg tracking-[0.18em] uppercase">İxirli</span>
          </div>
          <p className="text-white/60 max-w-md text-sm leading-relaxed">
            {lang === "tr"
              ? "Gaziantep merkezli yaratıcı prodüksiyon ve dijital reklam ajansı. Fikirleri görüntüye, markaları hikâyeye dönüştürüyoruz."
              : "Gaziantep-based creative production and digital ad agency. We turn ideas into images, brands into stories."}
          </p>
        </div>
        <div>
          <h4 className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] mb-4 uppercase">
            {lang === "tr" ? "İletişim" : "Contact"}
          </h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-2"><Phone size={13} /> {settings.phone}</li>
            <li className="flex items-center gap-2"><Mail size={13} /> {settings.email}</li>
            <li className="flex items-center gap-2"><MapPin size={13} /> {settings.location}</li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] mb-4 uppercase">Follow</h4>
          <div className="flex items-center gap-3">
            <a href={settings.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-full hover:border-[#A855F7]/60 transition-colors"><Instagram size={14} /></a>
            <a href={settings.youtube} target="_blank" rel="noreferrer" className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-full hover:border-[#A855F7]/60 transition-colors"><Youtube size={14} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between text-xs text-white/40">
          <span>{pick(settings, "footer") || settings.footer_tr}</span>
          <span className="font-mono-ui">v1.0 · {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
}
